import "src/pages/home/components/RoomCard/RoomCardXS/sections/shared/Wrapper/Wrapper.css"
import "src/pages/home/components/RoomCard/RoomCardXS/RoomCardXS.css"
import SkeletonItem from "./SkeletonItem"

function SkeletonCardLG() {
    return (
        <div className="room-card--xs__container">
            <div className="room-card--xs__wrapper" style={{ backgroundColor: "var(--white)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <SkeletonItem width={26} height={26} borderRadius="50%" />
                    <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-end" }}>
                        <SkeletonItem width={70} height={12} borderRadius={6} />
                        <SkeletonItem width={28} height={12} borderRadius={6} />
                    </div>
                </div>
                <SkeletonItem width="40%" height={12} borderRadius={6} />
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <SkeletonItem width="40%" height={12} borderRadius={6} />
                    <SkeletonItem width={28} height={12} borderRadius={6} />
                </div>
            </div>
        </div>
    )
}

export default SkeletonCardLG
